import React from 'react'
import { SvgChiliPiper } from '@chilipiper/icons'
import { Icon } from '../icon'
import { Text } from '../../new/core-components/text'
import { Box } from '../../new/core-components/box'
import { Divider } from '../../new/core-components/divider'
import { Stack } from '../../new/core-components/stack'

type Variant = 'regular' | 'emailSignature'

interface Props {
  anchorLink?: string
  variant?: Variant
}

export const BrandingFooter = ({
  anchorLink = 'https://www.chilipiper.com/page/powered-by-chili-piper?utm_medium=product&utm_source=vir&utm_campaign=bookinglink',
  variant = 'regular',
}: Props) => {
  const variants = {
    regular: {
      justify: 'center',
      textColor: 'text/body-moderate',
      textStyle: 'body-monoline',
      linkTextStyle: 'button',
      py: 4,
    },
    emailSignature: {
      justify: 'start',
      textColor: 'text/detail-moderate',
      textStyle: 'detail-m',
      linkTextStyle: 'heading-xs',
      py: 3,
    },
  } as const

  const { justify, textColor, textStyle, linkTextStyle, py } = variants[variant]
  return (
    <Box>
      <Divider mb='-1px' />
      <Stack
        spacing={1}
        direction='row'
        data-chili-css='footer'
        data-test-id='BrandingFooter'
        alignItems='center'
        justifyContent={justify}
        py={py}
      >
        <Icon
          data-chili-css='logo-footer'
          icon={SvgChiliPiper}
          w={4}
          h={4}
          color='icon/cp-logo'
          mr={1}
        />
        <Text data-chili-css='powered-by-footer' color={textColor} textStyle={textStyle}>
          Powered by
        </Text>
        <Text
          as='a'
          color='text/action-brand'
          textStyle={linkTextStyle}
          data-chili-css='name-footer'
          target='_blank'
          href={anchorLink}
        >
          Chili Piper
        </Text>
      </Stack>
    </Box>
  )
}
